import {createSelector} from '@reduxjs/toolkit';

export const selectArea = (area) => {
	const selectLoading = (store) => store.loading;

	return createSelector(selectLoading, (loading) => {
		return loading.areas[area];
	});
};

export const selectAreas = (areas) => {
	const selectLoading = (store) => store.loading;

	return createSelector(selectLoading, (loading) => {
		const collectionLoadingAreas = areas.map(
			(area) => loading.areas[area]?.toString() ?? false
		);

		return collectionLoadingAreas.includes('true');
	});
};
